import React from 'react';
import classNames from 'classnames';
export function BuyGlobalLoading(_a) {
    var _b;
    var className = _a.className, size = _a.size, type = _a.type, style = _a.style;
    return (React.createElement("div", { className: classNames('buy-loading', 'buy-order-pay-loading', (_b = {},
            _b["size-" + size] = typeof size !== 'undefined',
            _b["buy-loading--" + type] = typeof type !== 'undefined',
            _b), className), style: style },
        React.createElement("div", { className: "buy-loading__inner" },
            React.createElement("div", { className: "buy-loading__dot" }),
            React.createElement("div", { className: "buy-loading__dot" }),
            React.createElement("div", { className: "buy-loading__dot" }))));
}
//# sourceMappingURL=BuyGlobalLoading.js.map